import { Stack } from '@mui/material'
import { useState } from 'react'
import TabsFilter from 'ui/breadCrumbs/TabsFilter'
import { Licenses } from './licenses/Licenses'
import { tabOptions, TabsKey } from './options/tab-options'
import { Questions } from './questions/Questions'

export const LicensesPage = () => {
	const [selectTab, setSelectTab] = useState<TabsKey>(TabsKey.LICENSE)
	const renderForm = () => {
		switch (selectTab) {
			case TabsKey.LICENSE:
				return <Licenses />
			case TabsKey.QUESTIONS:
				return <Questions />
			default:
				return null
		}
	}
	return (
		<Stack direction={'column'} gap={'40px'} sx={{ padding: '0 16px 0 8px' }}>
			<TabsFilter
				onClick={key => setSelectTab(key)}
				availableTabs={tabOptions}
			/>
			{renderForm()}
		</Stack>
	)
}
